import { Kanban } from "@common-models/kanban";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createSelector } from "@reduxjs/toolkit";
import { kanbanSelectByQuery } from "@common-reducers/DBServiceThunks";
import { CommonRootState } from "@common/types/common-root-state-type";

export const kanbanIdList = createSelector(
  [
    (state: CommonRootState, boardId: string) => kanbanSelectByQuery(state.DBKanbanReducer, { boardId })
  ],
  (kanbanList: Kanban[]) => {
    const kanbanIdList = kanbanList.map((kanban) => kanban._id)
    return kanbanIdList
  }
);

export interface KanbanState {
  settingsMode: boolean;
}

const initialState: KanbanState = {
  settingsMode: false,
}


const kanbanSlice = createSlice({
  name: "task",
  initialState,
  reducers: {
    setSettingsMode(state, action: PayloadAction<boolean>) {
      state.settingsMode = action.payload;
    },
  }
})

export default kanbanSlice.reducer;

export const kanbanActions = kanbanSlice.actions;